import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Blogs extends Component {
  state = {
    blogs: [],
    formData: {
      id: null,
      admin_id: "",
      blog_description: "",
      blog_title: "",
      blog_date: "",
      blog_status: "1",
      blog_img: null,
    },
    imagePreview: "",
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
  };

  componentDidMount() {
    this.fetchBlogs();

    const modalEl = document.getElementById("blogModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.resetForm();
      });
    }
  }

  /** ✅ Fetch all Blogs */
  fetchBlogs = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("/blogs", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data?.data || [];
      this.setState({ blogs: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error:
          err.response?.data?.message ||
          "Failed to load blogs. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** ✅ Reset form */
  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        admin_id: "",
        blog_description: "",
        blog_title: "",
        blog_date: "",
        blog_status: "1",
        blog_img: null,
      },
      imagePreview: "",
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  /** ✅ Input change */
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        [name]: value,
      },
    }));
  };

  /** ✅ File change */
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState((prev) => ({
        formData: {
          ...prev.formData,
          blog_img: file,
        },
        imagePreview: URL.createObjectURL(file),
      }));
    }
  };

  /** ✅ Open modal */
  openModal = (mode = "add", blog = null) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("blogModal")
    );
    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    if (mode === "edit" && blog) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: blog.id,
          admin_id: blog.admin_id || "",
          blog_description: blog.blog_description || "",
          blog_title: blog.blog_title || "",
          blog_date: blog.blog_date ? blog.blog_date.split(" ")[0] : "",
          blog_status: blog.blog_status?.toString() ?? "1",
          blog_img: null,
        },
        imagePreview: blog.blog_img
          ? `${baseUrl}/uploads/blogs/${blog.blog_img}`
          : "",
        error: "",
      });
    } else {
      this.resetForm();
    }

    modal.show();
  };

  /** ✅ Submit add/update */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.admin_id) {
      return this.setState({ error: "Admin Name is required." });
    }
    if (!formData.blog_description) {
      return this.setState({ error: "Blog description is required." });
    }
    if (!formData.blog_title) {
      return this.setState({ error: "Blog title is required." });
    }
    if (!formData.blog_date) {
      return this.setState({ error: "Blog date is required." });
    }
    if (formData.blog_status === "") {
      return this.setState({ error: "Status is required." });
    }

    const data = new FormData();
    data.append("admin_id", formData.admin_id);
    data.append("blog_description", formData.blog_description);
    data.append("blog_title", formData.blog_title);
    data.append("blog_date", formData.blog_date);
    data.append("blog_status", formData.blog_status);

    if (formData.blog_img) {
      data.append("blog_img", formData.blog_img);
    }

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");

      if (modalMode === "add") {
        await axios.post("/blogs", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.post(`/blogs/${formData.id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      await this.fetchBlogs();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("blogModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "Blog added successfully!"
            : "Blog updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving blog.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** ✅ Confirm delete */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(
      document.getElementById("deleteModal")
    );
    modal.show();
  };

  /** ✅ Delete blog */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/blogs/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await this.fetchBlogs();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("deleteModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title: "Blog deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Failed to delete blog.",
      });
    }
  };

  render() {
    const {
      blogs,
      formData,
      imagePreview,
      error,
      loading,
      submitting,
      modalMode,
    } = this.state;

    const baseUrl = axios.defaults.baseURL.replace("/api", "");

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Blogs</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>

                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New Blog
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}

                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Admin ID</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Date</th>
                            <th>Image</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {blogs.length > 0 ? (
                            blogs.map((blog, index) => (
                              <tr key={blog.id}>
                                <td>{index + 1}</td>
                                <td>{blog.admin_id}</td>
                                <td>{blog.blog_title}</td>
                                <td>{blog.blog_description}</td>
                                <td>{blog.blog_date}</td>
                                <td>
                                  {blog.blog_img ? (
                                    <img
                                      src={`${baseUrl}/uploads/blogs/${blog.blog_img}`}
                                      alt="Blog"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        objectFit: "cover",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                                <td>
                                  {blog.blog_status === "1" ||
                                  blog.blog_status === 1 ? (
                                    <span className="badge bg-success">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() => this.openModal("edit", blog)}
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>

                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() => this.confirmDelete(blog.id)}
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No blogs found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add / Edit Modal */}
        <div className="modal fade" id="blogModal" tabIndex={-1}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add" ? "Add Blog" : "Edit Blog"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  {/* Admin ID */}
                  <div className="mb-3">
                    <label className="form-label">Admin Name</label>
                    <input
                      type="text"
                      name="admin_id"
                      className="form-control"
                      value={formData.admin_id}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  {/* Blog Title */}
                  <div className="mb-3">
                    <label className="form-label">Blog Title</label>
                    <input
                      type="text"
                      name="blog_title"
                      className="form-control"
                      value={formData.blog_title}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  {/* Blog Description */}
                  <div className="mb-3">
                    <label className="form-label">Blog Description</label>
                    <input
                      type="text"
                      name="blog_description"
                      className="form-control"
                      value={formData.blog_description}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  {/* Blog Date */}
                  <div className="mb-3">
                    <label className="form-label">Blog Date</label>
                    <input
                      type="date"
                      name="blog_date"
                      className="form-control"
                      value={formData.blog_date}
                      onChange={this.handleChange}
                      required
                    />
                  </div>

                  {/* Blog Status */}
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      name="blog_status"
                      className="form-select"
                      value={formData.blog_status}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>

                  {/* Blog Image */}
                  <div className="mb-3">
                    <label className="form-label">Blog Image</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={this.handleFileChange}
                    />

                    {imagePreview && (
                      <div className="mt-2 text-center">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {error && <div className="alert alert-danger">{error}</div>}
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-light-primary"
                    disabled={submitting}
                  >
                    {submitting
                      ? "Saving..."
                      : modalMode === "add"
                      ? "Add"
                      : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Delete Modal */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>

                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={this.handleDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Blogs;